import React from 'react'
import PropTypes from 'prop-types'
import { reduxForm } from 'redux-form'
import VenueDetailsFields from './details'

const VenueForm = ({ form }) => {
  return (
    <>
      <VenueDetailsFields form={form} />
    </>
  )
}

VenueForm.propTypes = {
  fieldName: PropTypes.string,
  form: PropTypes.string,
}

export default reduxForm({ enableReinitialize: true })(VenueForm)
